import { useCallback, useEffect, useState } from "react";
import { SmoothScroll } from "@/components/site/SmoothScroll";
import { Intro } from "@/components/site/Intro";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Marquee } from "@/components/site/Marquee";
import { Bio } from "@/components/site/Bio";
import { InstagramFeed } from "@/components/site/InstagramFeed";
import { Calendar } from "@/components/site/Calendar";
import { News } from "@/components/site/News";
import { Gallery } from "@/components/site/Gallery";
import { Sponsors } from "@/components/site/Sponsors";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { fetchSiteData } from "@/lib/api";

const INTRO_KEY = "lp_intro_seen";
const EMPTY = { results: [], races: [], news: [], gallery: [], sponsors: [] };

export default function Home() {
  const [data, setData] = useState(EMPTY);
  const [showIntro] = useState(() => !sessionStorage.getItem(INTRO_KEY));
  const [ready, setReady] = useState(() => !!sessionStorage.getItem(INTRO_KEY));
  const [contactType, setContactType] = useState("sponsor");

  useEffect(() => {
    let alive = true;
    fetchSiteData().then((d) => { if (alive) setData(d); }).catch(() => {});
    return () => { alive = false; };
  }, []);

  const onIntroDone = useCallback(() => {
    sessionStorage.setItem(INTRO_KEY, "1");
    setReady(true);
  }, []);

  return (
    <SmoothScroll>
      <div className="grain bg-ink" data-testid="home-page">
        {showIntro && <Intro onDone={onIntroDone} />}
        <Nav />
        <main>
          <Hero ready={ready} races={data.races} />
          <Marquee />
          <Bio />
          <InstagramFeed />
          <Calendar races={data.races} />
          <News news={data.news} />
          <Gallery gallery={data.gallery} />
          <Sponsors sponsors={data.sponsors} onBecomePartner={() => setContactType("sponsor")} />
          <Contact type={contactType} setType={setContactType} />
        </main>
        <Footer />
      </div>
    </SmoothScroll>
  );
}
